module.exports = __webpack_public_path__ + "static/media/Avatar-6.717c4ade.png";